import { z } from 'zod';
import { $CandidateFileType } from './CandidateFileType';

export const $CandidatePhoto = z.object({
  id: z.number(),
  name: z.string(),
  extension: z.string(),
  size: z.number(),
  absolutePath: z.string(),
  type: $CandidateFileType.optional(),
  scope: z.string().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
});
